import React from 'react';
import ConnectToStores from '../Utilities/Decorators/ConnectToStoresDecorator';
import NotificationActions from '../Actions/NotificationActions';
import NotificationStore from '../Stores/NotificationStore';
import BindOnce from '../Utilities/Decorators/BindOnceDecorator';
import AutoScopeStyles from '../Utilities/Decorators/AutoScopeStylesDecorator';
import MessageView from './MessageView.jsx';
import applyDecoratorsDoNotUseInNewCode from '../Utilities/Decorators/ApplyDecorators';

class NotificationsView extends React.Component {
    static getStores() {
        return [NotificationStore];
    }

    static getPropsFromStores() {
        return NotificationStore.getState();
    }

    render() {
        if(this.props.notificationDetails) {
            return <MessageView {...this.props.notificationDetails } onClose={ this.bindOnce(this.onCloseButtonClick) } />;
        }
        else {
            return null;
        }
    }

    onCloseButtonClick() {
        NotificationActions.clearNotifications();
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(ConnectToStores, BindOnce, AutoScopeStyles);

export default withDecorators(NotificationsView);
